module.exports = __webpack_public_path__ + "static/media/v11.1ada58e0.mp4";